import React, { useState, useReducer } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, getPromotionTextColor, getPromotionBgColor, isNotEmpty, getPromotionMainColor, colorToArray } from '../../lib/ep.js';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';

import { CreateButton } from '../builder/ActionButton.js';
import { AutoPostImageUploader } from '../builder/ImageUploader.js';
import BuilderCanvas from '../builder/BuilderCanvas.js';
import BuilderSidebar from '../builder/BuilderSidebar.js';
import Checkbox from '../builder/Checkbox.js';
import ColorPicker from '../builder/ColorPicker.js';
import DynamicFields from '../builder/DynamicFields.js';
import Model from '../builder/Model.js';
import { NavigationTabsBuilder } from '../builder/NavigationTabs.js';
import Select from '../builder/Select.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import SectionTitle from '../builder/SectionTitle.js';
import BuilderMain, { BuilderMainWithoutSidebar } from '../builder/BuilderMain.js';

import Layout from '../front/Layout.js';
import PunchCardClient from '../front/PunchCardClient.js';

import BuilderSubSectionTitle from './BuilderSubSectionTitle.js';
import Message, { AlertMessage } from '../builder/Message.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import ToggleButton from '../builder/ToggleButton.js';
import ActionLink from '../builder/ActionLink.js';

const PunchCanvasBuilder = ({ stage, state, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const is_test = props?.is_test ?? false;
	const is_enabled = props?.is_enabled ?? true;

	const [ display_stamps, setDisplayStamps ] = useState(false);
	const [ display_move_area, setDisplayMoveArea ] = useState(false);
	const [ display_button, setDisplayButton ] = useState(false);

	if(!is_enabled) {
		return (
			<BuilderCanvas fit_to_window="content">
				<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promo_menu} layout_extra_classes="is_new_game">
					<div style={{width:'100%', height:'100%'}}>
						<img src={`${window.cdn_url}img/blank_1x1.png`} width="100%" />
						<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
							<p>{i18n("Please, complete all the game options on the left")}</p>
						</div>
					</div>
				</Layout>
			</BuilderCanvas>
		)
	}

	const areaChanged = (type, area) => {
		if(is_test) return;
		change('punch_group_area', area);
	};

	return (
		<BuilderCanvas
			fit_to_window="content"
			off_content={<>
				<ButtonCollection
					style={{ '--button-icon-top':'-1px' }}
				>
					<ToggleButton
						active={display_stamps}
						onClick={() => setDisplayStamps(!display_stamps)}
						icon='knk-slide-on'
						icon_off='knk-slide-off'
						color={(display_stamps) ? null : 'darkgray'}
					>View stamps</ToggleButton>

					<ToggleButton
						active={display_move_area}
						onClick={() => setDisplayMoveArea(!display_move_area)}
						icon='knk-slide-on'
						icon_off='knk-slide-off'
						color={(display_move_area) ? null : 'darkgray'}
					>Edit position</ToggleButton>

					<ToggleButton
						active={display_button}
						onClick={() => setDisplayButton(!display_button)}
						icon='knk-slide-on'
						icon_off='knk-slide-off'
						color={(display_button) ? null : 'darkgray'}
					>Display Continue button</ToggleButton>
				</ButtonCollection>
			</>}
		>
			<Layout promo={props.promotion} is_builder={true} page="quiz" menus={props.promo_menu} layout_extra_classes="is_new_game">
				<PunchCardClient
					stage={{
						Stage:{
							...stage,
							// reveal_win:state.reveal_win,
							// scratch:state.scratch
						}
					}}
					promotion={props.promotion}
					participations={{
						[stage.id]:{
							num_participations:(display_stamps) ? parseInt(stage.punch_num_punches) : 0,
						}
					}}
					is_editing={display_move_area}
					force_display_stamps={display_stamps}
					display_button={display_button}
					areaChanged={areaChanged}
					is_builder={true}
				/>
				
			</Layout>
		</BuilderCanvas>
	)
};

const PunchImage = ({ model, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ uploading, setUploading ] = useState(false);

	const auto_img_hooks = (hook) => {
		switch(hook.type) {
			case 'AUTO_IMAGE_START':
				setUploading(true);
				break;

			case 'AUTO_IMAGE_END':
				setUploading(false);
				break;
		}
	}
	
	const punches = [{k:"", v:`-- ${i18n("Select a position")} --`}];
	for (var i = 1; i <= parseInt(props.stage.punch_num_punches); i++) {
		punches.push({k:i,v:i});
	}
	const used = props.stage.punch_images.filter(image=>{
		if (image.id == model.id) return false;
		return true;
	}).map(image=>(parseInt(image.position)))
	const values = punches.filter(punch=>(!used.includes(punch.k)) || punch.k == '');

	return (
		<Model
			model={model}
			change={change}
			errors={props.errors != undefined && props.errors[model.id]}
		>
			<Select
				name='position'
				_class={{ size:60 }}
				values={values}
			>Position</Select>

			<AutoPostImageUploader
				auto_url={`/promotions/auto_img/${props.promotion_id}`}
				auto_type='stages'
				changeMulti={props.changeMulti}
				hooks={auto_img_hooks}
				image={model?.image_off != '' ? model.full_image_off :undefined}
				name="image_off"
				small_input={true}
				_size={{ width:120, height:120 }}
			>Unstamped image</AutoPostImageUploader>

			<AutoPostImageUploader
				auto_url={`/promotions/auto_img/${props.promotion_id}`}
				auto_type='stages'
				changeMulti={props.changeMulti}
				hooks={auto_img_hooks}
				image={model?.image_on != '' ? model.full_image_on:undefined}
				name="image_on"
				small_input={true}
				_size={{ width:120, height:120 }}
			>Stamped image</AutoPostImageUploader>

			{(props?.display_text_color ?? true) && (
				<ColorPicker
					_class={{ size:60 }}
					_hide_code={true}
					name="color"
					color={model?.color ?? 'rgba(30, 34, 170, 1)'}
				>Position text color</ColorPicker>
			)}
		</Model>
	)
};

const PunchSettings = ({ stage, change, dispatch, state, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const saveStage = (cb) => {
		props.saveStage(cb);
	};

	const autouploader_props = {
		auto_url:`/promotions/auto_img/${stage.promotion_id}`,
		auto_type:'stages',
		display_custom_dragging_instructions:"Upload the image",
		thumb_w:80,
		_size:{
			width:120,
			height:120,
		},
	};
	
	const prizes_to_images = (stage.reveal_mode == 'win') ? state.reveal_win : state.scratch;

	const dynamic_fields = [{
		type:'stamp_image',
		label:"Stamp",
		// translate:[
		// 	{key:'feedback',type:'textarea'}
		// ],
		title:(f) => {
			//if(isNotEmpty(f, 'title')) return props.intl.formatMessage({ id:"{title} (row {row})"}, { title:f.title, row:milestone_level});
			return props.intl.formatMessage({ id:"Stamp position at {pos}" }, { pos:f.position });
		},
		max:5,
	}];

	const no_prize = prizes_to_images.find(i=>(i.id ==0));

	const num_options = [];
	for(var i = 3; i <= 20; i++) {
		num_options.push({ k:i, v:i })
	}

	const distribution_options = [{ k:'honeycomb', v:"Honeycomb" }, { k:'uniform', v:"Uniform" }];
	const stamp_shape_options = [{ k:'circle', v:"Circle" }, { k:'rect', v:"Square" }];
	const default_stamp_punches = stage?.punch_num_punches ?? 5;

	const prizes_with_punch_conditions_equal_to_num_stamps = (props.prizes ?? []).filter((p) => ((p?.conditions ?? []).some(c => c.field == 'stamp' && c.operator == '=' && c.value == default_stamp_punches))).length > 0;
	return (
		<>
			<BuilderSidebar onSave={saveStage}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<BuilderSubSectionTitle
						title="Stamps"
						icon='knk-brand'
					/>

					<Model model={stage} change={change}>
						<Select
							_class={{ size:30 }}
							name="punch_num_punches"
							values={num_options}
							value={default_stamp_punches}
						>Number of stamps per card</Select>

						{(!prizes_with_punch_conditions_equal_to_num_stamps) && (
							<AlertMessage
								title="Attention!"
								_class={{ other:'tip_message' }}
							>
								<p>
									{props.intl.formatMessage({ id:"The prize that will be automatically awarded after completing the {num_stamps} stamps is not configured." }, { num_stamps:default_stamp_punches })}
									<ActionLink
										_href={`${window.zendesk_base_url}24307741022612`}
										_target='_blank'
									>How is it done?</ActionLink>
								</p>
							</AlertMessage>
						)}
						

						<Select
							_class={{ size:50}}
							name="punch_distribution"
							values={distribution_options}
							value={stage?.punch_distribution ?? 'honeycomb'}
						>Stamp distribution</Select>

						<Select
							_class={{ size:50}}
							name="punch_shape"
							values={stamp_shape_options}
							value={stage?.punch_shape ?? 'circle'}
						>Stamp shape</Select>

						<Checkbox
							name='punch_display_punch_numbers'
							value={stage?.punch_display_punch_numbers ?? true}
						>Display stamp position numbers</Checkbox>

						{(stage?.punch_display_punch_numbers ?? true) && (
							<ColorPicker
								_class={{size:40}}
								_hide_code={true}
								name="punch_text_color"
								color={stage?.punch_text_color ?? getPromotionTextColor(props.promotion)}
							>Position text color</ColorPicker>
						)}

						<AutoPostImageUploader
							{...autouploader_props}
							image={stage.full_punch_image_off}
							changeMulti={props.changeMulti}
							name='punch_image_off'
							_size={{
								width:120,
								height:120,
							}}
						>Unstamped image</AutoPostImageUploader>

						{(!isNotEmpty(stage, 'full_punch_image_off')) && (
							<ColorPicker
								_class={{size:40}}
								_hide_code={true}
								name="punch_off_color"
								color={stage?.punch_off_color ?? `rgba(${colorToArray(getPromotionTextColor(props.promotion))}, 0.2)`}
							>Unstamped color</ColorPicker>
						)}

						<AutoPostImageUploader
							{...autouploader_props}
							image={stage.full_punch_image_on}
							changeMulti={props.changeMulti}
							name='punch_image_on'
							_size={{
								width:120,
								height:120,
							}}
						>Stamped image</AutoPostImageUploader>
 
						{(!isNotEmpty(stage, 'full_punch_image_on')) && (
							<ColorPicker
								_class={{size:40}}
								_hide_code={true}
								name="punch_on_color"
								color={stage?.punch_on_color ?? getPromotionMainColor(props.promotion)}
							>Stamped color</ColorPicker>
						)}
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<DynamicFields
						section_title="Customize individual stamps"
						onChange={(v) => change('punch_images', v)}
						field_types={dynamic_fields}
						add_button_props={{
							icon:'knk-add-item mainButton',
						}}
						sortable={false}
						fields={stage?.punch_images ?? []}
					>
						<PunchImage
							promotion_id={stage.promotion_id}
							display_text_color={stage?.punch_display_punch_numbers ?? true}
							stage={stage}
							errors={{}}
							intl={props.intl}
						/>
					</DynamicFields>

					<Message>
						<p>{i18n("You will be able to customize the design of a stamp in a specific position on the card.")}</p>
					</Message>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title="Card background"
						icon='knk-picture'
					/>

					<Model model={stage} change={change}>
						<AutoPostImageUploader
							{...autouploader_props}
							image={(stage.full_bg_image != "") ? stage.full_bg_image : undefined}
							changeMulti={props.changeMulti}
							name='bg_image'
							_size={{
								width:720,
								height:1160,
							}}
						>Image</AutoPostImageUploader>

						{(!isNotEmpty(stage, 'full_bg_image')) && (
							<ColorPicker
								_class={{size:40}}
								_hide_code={true}
								name="bg_color"
								color={stage?.bg_color ?? getPromotionBgColor(props.promotion)}
							>Color</ColorPicker>
						)}
					</Model>
				</article>
			</BuilderSidebar>

			<PunchCanvasBuilder
				change={change}
				stage={stage}
				state={state}
				promotion={props.promotion}
				prizes={props.prizes}
				promo_menu={props.promoModel.Custom__Menus}
				intl={props.intl}
			/>
		</>
	)
};

const PunchCardBuilder = ({ base_route, ...props }) => {
	const basename = `/stages/${props.stage.id}/stamps`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${props.stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Settings", link:`${basename}/settings`, icon:'knk-settings' },
	];

	const stage = props.stage;

	const prizeIsAvailable = (p) => {
		if(!['4','5'].includes(p.assignation)) return false;
		if(p.stage_id == null) return true;
		if(p.stage_id == stage.id) return true;
		return false;
	};

	const generateWin = () => {
		if(stage.reveal_win) return stage.reveal_win;
		stage.reveal_win = [
			{ id:0, type:'reveal_win' },
			{ id:'prize', type:'reveal_win' },
		];
		return stage.reveal_win;
	};

	const generateScratch = () => {
		if(stage.scratch) {
			let present = stage.scratch.map((p) => p.id);

			const current_prizes = props.prizes.map((p) => p.id);
			stage.scratch = stage.scratch.filter((p) => {
				if(p.id == 0) return true;
				if(!current_prizes.includes(p.id)) return false;
				return true;
			});

			const reveal_no_win = stage.reveal_win.find(p=>p.id ==0);
			const no_prize =  reveal_no_win ? {...reveal_no_win,type:'reveal_prize'} :{ id:0, type:'reveal_prize' };

			if(!present.includes(0)) {
				present.push(0);
				stage.scratch = [...stage.scratch, no_prize];
			} else {
				stage.scratch.map(p=>{
					if (p.id != 0) return p;
					return no_prize;
				})
			}
			
			stage.scratch = stage.scratch.filter((p) => present.includes(p.id));

			props.prizes.filter(prizeIsAvailable).map((p) => {
				if(present.includes(p.id)) return;
				stage.scratch.unshift({ id:p.id, type:'reveal_prize' });
			});

			return stage.scratch;
		};

		const prizes_in_scratch = [...props.prizes.filter(prizeIsAvailable).map((p) => ({ id:p.id, type:'scratch_prize' })), { id:0, type:'scratch_prize' }];
		return prizes_in_scratch;
	};
	
	const [state, dispatch] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE_REVEAL_WIN':
				return { ...state, reveal_win:[...action.v] };

			case 'CHANGE_REVEAL_PRIZES':
				return { ...state, scratch:[...action.v] };

			default:
				return state;
		}
	}, {
		reveal_win:generateWin(),
		scratch:generateScratch(),
	});

	if(props.prizes.length < 1) {
		return (
			<BuilderMainWithoutSidebar pm={props.promoModel} has_tabs={true}>
				<NavigationTabsBuilder
					relative_selection={true}
					sections={[{ label:"Go back", link:`/stages/${props.stage.id}/options`, icon:'knk-go-prev' }]}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<section class="not_awesome">
					<div>
						<div class="gui_section_header alone_section_header cleared_header">
							<SectionTitle _class={{other:'in_top'}}>No prize defined</SectionTitle>

							<CreateButton
								_href="#prizes"
							>Go to Prize Editor and Create my first prize</CreateButton>
						</div>

						<SectionSubtitle>You must create at least one prize before you configure the game.</SectionSubtitle>
					</div>
				</section>
			</BuilderMainWithoutSidebar>
		)
	}

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<PunchSettings
							change={props.change}
							changeMulti={props.changeMulti}
							intl={props.intl}
							nav_active={`/settings`}
							nav_sections={nav_sections}
							promotion={props.promotion}
							promoModel={props.promoModel}
							instantStore={props.instantStore}
							prizes={props.prizes}
							saveStage={props.saveStage}
							winnerStore={props.winnerStore}
							dispatch={dispatch}
							stage={stage}
							state={state}
							stage_indicator={props.stage_indicator}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
}
export default injectIntl(PunchCardBuilder);